import { ref, createVNode, render } from 'vue';
import Alert from './Alert.vue';

export default {
  install(app) {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const instance = createVNode(Alert);
    instance.appContext = app._context;
    render(instance, container);

    app.component('Alert', Alert);
    app.provide('alert_plugin', instance.component.exposed.alert);

    // DEPRECATED
    app.provide('ac', instance.component.exposed.alert);
    app.provide('alert', instance.component.exposed.alert);

  }
};
